import React from 'react';
import ErrorMessage from '../../components/ErrorMessage';

const NotFoundPage = () => {
  return <ErrorMessage message="Page Not Found" showHomeLink />;
};

export default NotFoundPage;
